import styled from 'styled-components'

import quarks from './quarks'
import Box from './box'
import makeExcludePropsConfig from './make-exclude-props-config'

const Stack = styled(Box).withConfig(
  makeExcludePropsConfig(['spacing', 'horizontal']),
)<{ spacing?: string | number; horizontal?: boolean }>`
  ${(p) =>
    p.horizontal &&
    `
    display: flex; 
  `}
  & > * + * {
    ${(p) =>
      p.horizontal
        ? `
        margin-left: ${p.spacing ?? quarks.margins.medium};
        `
        : `
        margin-top: ${p.spacing ?? quarks.margins.medium};
        `}
  }
`

export default Stack
